import { Route } from '@angular/router';
import {
  DelegatedRequestContextAdapter,
  EMPLOYEE_ROUTES,
  FEATURE_FLAG_KEY,
  FEATURE_FLAGS,
  REQUEST_CONTEXT_ADAPTER,
  canDeactivateGuard,
  myTeamRoutes,
  pathAllowedByFeatureFlagGuard,
} from '@kuiper/ibusiness-core';
import { provideBackgroundTasksAccountTab } from '../pages/employee-flow/background-tasks/background-tasks-account-tab';
import { contractDetailsResolver } from '../pages/employee-flow/projects/project-details/contract-tab/contract-details/contract-details.resolver';

export const employeeRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: EMPLOYEE_ROUTES.HOME,
  },
  {
    path: EMPLOYEE_ROUTES.HOME,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.EmployeeHomeComponent;
    },
  },
  {
    path: EMPLOYEE_ROUTES.REQUESTS.LIST,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.RequestListComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.REQUESTS.DETAILS}/:id`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.RequestDetailsComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.REQUESTS.DETAILS}/:requestId/${EMPLOYEE_ROUTES.REQUESTS.SCHEDULE}`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.ScheduleWorkflowComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.REQUESTS.DETAILS}/:requestId/${EMPLOYEE_ROUTES.REQUESTS.SCHEDULE}/${EMPLOYEE_ROUTES.REQUESTS.ACTION.VIEW}/:scheduleId`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.ScheduleDetailsComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.REQUESTS.DETAILS}/:requestId/${EMPLOYEE_ROUTES.REQUESTS.SCHEDULE}/:scheduleId`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.ScheduleWorkflowComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.REQUESTS.DETAILS}/:requestId/:requestAction`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.RequestComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.REQUESTS.REQUEST}/:requestAction/:flowId`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.RequestViewComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.REQUESTS.DETAILS}/:requestId/:requestAction/:projectId`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.RequestComponent;
    },
  },
  {
    path: EMPLOYEE_ROUTES.MY_INBOX.LIST,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.MyInboxComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.MY_INBOX.REQUEST}/:requestAction/:flowId`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.RequestViewComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.MY_INBOX.LIST}/${EMPLOYEE_ROUTES.MY_INBOX.DELEGATED}/:stepId/:requestAction/:flowId`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.RequestComponent;
    },
    providers: [
      {
        provide: REQUEST_CONTEXT_ADAPTER,
        useExisting: DelegatedRequestContextAdapter,
      },
    ],
  },
  {
    path: `${EMPLOYEE_ROUTES.MY_INBOX.LIST}/:stepId/:requestAction/:flowId`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.RequestComponent;
    },
  },
  {
    path: EMPLOYEE_ROUTES.PROJECTS.LIST,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/projects/project-list-new-design/project-list-new-design.component');
      return c.ProjectListNewDesignComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.PROJECTS.FORM}/:typeId/:slug/:isChild`,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/projects/project-form/project-form.component');
      return c.ProjectFormComponent;
    },
  },

  {
    path: `${EMPLOYEE_ROUTES.PROJECTS.FORM}/:id`,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/projects/project-form/project-form.component');
      return c.ProjectFormComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.PROJECTS.DETAILS}/:id`,
    canDeactivate: [canDeactivateGuard],
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/projects/project-details/project-details.component');
      return c.ProjectDetailsComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.PROJECTS.LIST}/:projectId/${EMPLOYEE_ROUTES.PROJECTS.CONTRACTS.CREATE}`,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/projects/project-details/contract-tab/contract-form/contract-form.component');
      return c.ContractFormComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.PROJECTS.LIST}/:projectId/${EMPLOYEE_ROUTES.PROJECTS.CONTRACTS.EDIT}/:contractId`,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/projects/project-details/contract-tab/contract-form/contract-form.component');
      return c.ContractFormComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.PROJECTS.LIST}/:projectId/${EMPLOYEE_ROUTES.PROJECTS.CONTRACTS.VIEW}/:contractId`,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/projects/project-details/contract-tab/contract-details/contract-details.component');
      return c.ContractDetailsComponent;
    },
    resolve: {
      contractDetails: contractDetailsResolver,
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.PROJECTS.LIST}/:projectId/${EMPLOYEE_ROUTES.EVENTS.FORM}`,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/projects/project-details/event-tab/event-form/event-form.component');
      return c.EventFormComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.PROJECTS.LIST}/:projectId/${EMPLOYEE_ROUTES.EVENTS.FORM}/:eventId`,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/projects/project-details/event-tab/event-form/event-form.component');
      return c.EventFormComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.PROJECTS.LIST}/:projectId/${EMPLOYEE_ROUTES.EVENTS.DETAILS}/:eventId`,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/projects/project-details/event-tab/event-details/event-details.component');
      return c.EventDetailsComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.PROJECTS.LIST}/:projectId/${EMPLOYEE_ROUTES.PROJECTS.BORROWINGS.CREATE}`,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/projects/project-details/project-financial-tab/borrowing/borrowing-form/borrowing-form.component');
      return c.BorrowingFormComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.PROJECTS.LIST}/:projectId/${EMPLOYEE_ROUTES.PROJECTS.BORROWINGS.EDIT}/:borrowingId`,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/projects/project-details/project-financial-tab/borrowing/borrowing-form/borrowing-form.component');
      return c.BorrowingFormComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.PROJECTS.LIST}/:projectId/${EMPLOYEE_ROUTES.PROJECTS.BORROWINGS.DETAILS}/:borrowingId`,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/projects/project-details/project-financial-tab/borrowing/borrowing-details/borrowing-details.component');
      return c.BorrowingDetailsComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.PROJECTS.LIST}/:projectId/${EMPLOYEE_ROUTES.PROJECTS.BORROWINGS.VIEW}/:borrowingId`,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/projects/project-details/project-financial-tab/borrowing/borrowing-view/borrowing-view.component');
      return c.BorrowingViewComponent;
    },
  },
  {
    path: EMPLOYEE_ROUTES.VENDORS.LIST,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/vendor/vendor-list/vendor-list.component');
      return c.VendorListComponent;
    },
  },
  {
    path: EMPLOYEE_ROUTES.VENDORS.FORM,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/vendor/vendor-form/vendor-form.component');
      return c.VendorFormComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.VENDORS.FORM}/:id`,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/vendor/vendor-form/vendor-form.component');
      return c.VendorFormComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.VENDORS.DETAILS}/:id`,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/vendor/vendor-details/vendor-details.component');
      return c.VendorDetailsComponent;
    },
  },
  {
    path: EMPLOYEE_ROUTES.ACCOUNT_SETTINGS.PROFILE_DETAILS,
    providers: [provideBackgroundTasksAccountTab()],
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.AccountSettingsComponent;
    },
  },
  {
    path: EMPLOYEE_ROUTES.ACCOUNT_SETTINGS.EDIT_PROFILE,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.EditProfileComponent;
    },
  },
  {
    path: EMPLOYEE_ROUTES.MY_ORGANIZATION.LIST,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.MyOrganizationComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.MY_ORGANIZATION.LIST}/:stepId/:requestAction`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.RequestComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.MY_ORGANIZATION.REQUEST}/:requestAction/:flowId/:stepId/:userId/:userType`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.RequestComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.MY_ORGANIZATION.REQUEST}/:requestAction/:flowId`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.RequestViewComponent;
    },
  },
  {
    path: EMPLOYEE_ROUTES.MY_TEAM.LIST,
    children: [...myTeamRoutes],
  },
  {
    path: EMPLOYEE_ROUTES.ORGANIZATIONS_HIERARCHY,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/organizations-hierarchy/organizations-hierarchy.component');
      return c.OrganizationsHierarchyComponent;
    },
  },
  {
    path: EMPLOYEE_ROUTES.INVOICES,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/invoices/invoice-list/invoice-list.component');
      return c.InvoiceListComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.INVOICES}/:id`,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/invoices/invoice-details/invoice-details.component');
      return c.InvoiceDetailsComponent;
    },
  },
  {
    path: EMPLOYEE_ROUTES.BACKGROUND_TASKS,
    redirectTo: `${EMPLOYEE_ROUTES.ACCOUNT_SETTINGS.PROFILE_DETAILS}?tab=background-tasks`,
  },
  {
    path: `${EMPLOYEE_ROUTES.BACKGROUND_TASKS}/:id`,
    canActivate: [pathAllowedByFeatureFlagGuard],
    data: {
      [FEATURE_FLAG_KEY]: FEATURE_FLAGS.DIB.invoice_excel_import,
    },
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/background-tasks/background-task-result.component');
      return c.BackgroundTaskResultComponent;
    },
  },
  {
    path: EMPLOYEE_ROUTES.CORPORATE_FINANCE.ROOT,
    canActivateChild: [pathAllowedByFeatureFlagGuard],
    data: {
      [FEATURE_FLAG_KEY]:
        FEATURE_FLAGS.SIDE_MENU.corporate_finance_and_time_deposit,
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: EMPLOYEE_ROUTES.CORPORATE_FINANCE.BORROWINGS,
      },
      {
        path: EMPLOYEE_ROUTES.CORPORATE_FINANCE.BORROWINGS,
        data: {
          [FEATURE_FLAG_KEY]:
            FEATURE_FLAGS.SIDE_MENU.corporate_finance_and_time_deposit,
        },
        async loadComponent() {
          const c =
            await import('../pages/employee-flow/corporate-finance/borrowings/borrowings-list.component');
          return c.BorrowingsListComponent;
        },
      },
      {
        path: EMPLOYEE_ROUTES.CORPORATE_FINANCE.TIME_DEPOSITS,
        data: {
          [FEATURE_FLAG_KEY]:
            FEATURE_FLAGS.SIDE_MENU.corporate_finance_and_time_deposit,
        },
        async loadComponent() {
          const c =
            await import('../pages/employee-flow/corporate-finance/time-deposits/time-deposits-list.component');
          return c.TimeDepositsListComponent;
        },
      },
    ],
  },
  {
    path: EMPLOYEE_ROUTES.BUSINESS_CALENDAR,
    async loadComponent() {
      const c =
        await import('../pages/employee-flow/business-calendar/business-calendar.component');
      return c.BusinessCalendarComponent;
    },
  },
  {
    path: EMPLOYEE_ROUTES.NOTIFICATIONS,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.NotificationFullViewComponent;
    },
  },
  {
    path: EMPLOYEE_ROUTES.ACCOUNT_SETTINGS.DELEGATION_FORM,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.DelegationFormComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.ACCOUNT_SETTINGS.DELEGATION_FORM}/:id`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.DelegationFormComponent;
    },
  },
  {
    path: `${EMPLOYEE_ROUTES.ACCOUNT_SETTINGS.DELEGATION_DETAILS}/:id`,
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.DelegationDetailsComponent;
    },
  },
];
